import{useLayoutEffect as e,useEffect as o}from"react";const t="undefined"!=typeof window?e:o;export{t as default};
//# sourceMappingURL=useLayoutEffect.js.map
